import { Box, Typography } from '@wishket/design-system';

import { Illust, ListItem } from '@/shared/Components';

const EmptySearch = ({ searchQuery }: { searchQuery: string }) => {
  return (
    <Box className="flex flex-col items-center gap-8 desktop:gap-12">
      <Box className="h-[140px] w-[210px] tablet:h-[160px] tablet:w-[240px]">
        <Illust name="hand_pencil" />
      </Box>
      <Box className="flex flex-col items-start gap-8">
        <Typography variant="subTitle1" className="font-medium text-w-gray-900">
          <span className="text-primary">‘{searchQuery}’</span>
          {'에 대한 검색 결과가 없습니다.'}
        </Typography>
        <Box className="flex flex-col gap-2">
          <ListItem>
            <Typography variant="body1" className="text-w-gray-700">
              단어의 철자가 정확한지 확인해 보세요.
            </Typography>
          </ListItem>
          <ListItem>
            <Typography variant="body1" className="text-w-gray-700">
              단어 수를 줄인 후 다시 검색해 보세요.
            </Typography>
          </ListItem>
          <ListItem>
            <Typography variant="body1" className="text-w-gray-700">
              두 단어 이상은 띄어쓰기를 확인해 보세요.
            </Typography>
          </ListItem>
        </Box>
      </Box>
    </Box>
  );
};

export default EmptySearch;
